import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  .new-colaborator-container {
    display: flex;
    flex-wrap: wrap;

    padding: 10px 0px;

    width: 80%;

    gap: 10px;

    color: #000;

    font-family: 'Inter';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .new-colaborator-title {
    color: #000;

    margin-bottom: 32px;

    font-family: 'Roboto';
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .new-colaborator-subtitle {
    display: flex;
    align-items: center;

    gap: 16px;
    margin-bottom: 24px;

    img {
      width: 16px;
      height: 16px;
    }

    color: #070707;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.16px;
  }

  .span-novo {
    color: var(--Preto-Principal, #070707);
    font-family: 'Roboto';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.16px;
  }

  .ate {
    margin-top: 15px;

    color: #000;

    font-family: 'Inter';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .comission-button {
    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;

    width: 24px;
    height: 24px;
    margin-top: 12px;

    background-color: transparent;

    border-radius: 50%;

    img {
      width: 12px;
      height: 12px;
    }
  }

  @media only screen and (max-width: 1440px) {
    .new-colaborator-container {
      width: 100%;
    }
  }
`
